import { z } from 'zod';
import { OwnerRecordNoKeysSchema } from '../../db/ownerRecord.js';
import { OwnerCornSchema } from '../../owner/owner.js';
export const GetOwnerApiSchema = {
    params: z.object({
        ownerId: OwnerCornSchema,
    }),
    response: OwnerRecordNoKeysSchema,
};
export const GetOwnerRequestSchema = GetOwnerApiSchema.params;
export const GetOwnerResponseSchema = GetOwnerApiSchema.response;
